/**
 * @file コンポーネント：フル動画ページヘッダー スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { zIndex } from "~/src/styles/constants";
import { mediaQuery } from "~/src/styles/mixins";

// スタイル
export const StyledHeader = styled.header`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: ${zIndex.header};
    width: 100%;
    height: 64px;
    box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.12),
        0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 3px 3px -2px rgba(0, 0, 0, 0.2);
    background-color: #ffffff;
`;

export const StyledHeaderNavigation = styled.div`
    display: flex;
    align-items: center;
    margin-left: 12px;

    ${mediaQuery.sp(`
        flex-direction: column;
    `)};
`;

export const StyledHeaderNavigationLogo = styled.h1`
    margin-right: 12px;

    ${mediaQuery.sp(`
        margin-right: 0;
        margin-bottom: 4px;
    `)};
`;

export const StyledHeaderNavigationLogoAnchor = styled.a`
    display: flex;
`;

export const StyledHeaderNavigationLogoImage = styled.img`
    width: 90px;
    height: 18px;
`;

export const HeaderRight = styled.div`
    display: flex;
    align-items: center;
    margin-left: auto;
    padding-right: 12px;
    gap: 8px;
`;

export const StyledHeaderButtonMenu = styled.button`
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    order: -1;
    margin-left: 12px;

    padding: 0;
    border: none;
    background-color: #ffffff;
`;

export const StyledHeaderButtonMenuAnchor = styled.a`
    display: block;
    color: #00214c;
    text-align: center;

    &.is-notification {
        position: relative;

        &::after {
            display: inline-block;
            position: absolute;
            top: 0;
            right: 0;
            width: 1em;
            height: 1em;
            border-radius: 50%;
            background-color: #ad401f;
            color: #ffffff;
            font-size: 15px;
            line-height: 1em;
            text-align: center;
            content: "!";
        }
    }
`;

export const StyledHeaderButtonMenuIcon = styled.span`
    display: block;
    margin-bottom: 4px;
    font-size: 21px;
    line-height: 32px;
`;

export const StyledHeaderButtonMenuText = styled.span`
    display: block;
    font-size: 10px;
    line-height: 12px;
    white-space: nowrap;
`;
